(function ($) {
    'use strict';
    /**
     * 通用业务逻辑类，pagefly页面专用
     */
    class GeneralBusinessLogic {
        constructor() {
            this.isMobile = __Xtool_Utils.isMobile();
            this.hasAppendSwiperCSS = false;
            this.calcLeft();
            //this.customSlider(); // 自定义slider，F页面轮播模块
            this.customSlider2(); // 自定义slider，耗材落地页Top Savings for You模块
            this.customSlider3(); // 自定义slider，D1 pro页Less time for higher productivity模块
            this.customSlider4(); // 自定义slider，D1 pro页They differ, with the same prowess模块
            this.customSlider5(); // 自定义slider，D1 pro页Our results speak for themselves模块
            this.customSlider6(); // 自定义slider，M1页面的轮播模块
            this.customSlider7(); // 自定义slider，f1页面的轮播模块
            this.customSlider8(); // 自定义slider，f1页面(mo)的轮播模块
            this.collectionTabSlider(); // collection tab下的slider，耗材落地页collection模块
            this.bindEvent(); // 绑定事件
            this.changeTabButton();  // 改变button，D1 pro页面
            this.accessoriesSwitch(); // 配件切换
        }
        // 自定义slider1
        customSlider() {
            if (this.isMobile) {
                return;
            }
            const $slideShows = $('[data-pf-type="Slideshow"]');
            if ($slideShows.length == 0) {
                return;
            }
            $slideShows.each((index, item) => {
                const $slideShow = $(item);
                if (!$slideShow.hasClass('custom-slider')) {
                    return;
                }
                this.insertSwipperCSS();
                $slideShow.hide();
                const $pfSlides = $slideShow.find('.pf-slide');
                let arr = [];
                $pfSlides.each((index1, item1) => {
                    const $pfSlide = $(item1);
                    const title = $pfSlide.find('.slider-title').text();  // 标题
                    const desc = $pfSlide.find('.slider-desc').html();  // 描述
                    const img = $pfSlide.find('.slider-image').prop("outerHTML");  // 图片
                    arr.push({ title, desc, img });
                });

                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                            <div class="slider-item">
                            <h2 class="slider-title">${t.title}</h2>
                            <p class="slider-desc">${t.desc}</p>
                            ${t.img}
                            </div>
                        </div>
                    `;
                }).join('');

                $slideShow.closest('[data-pf-type="Section"]').css({ height: '150px' }).after(`
                    <style>
                        .swiper-container {
                            width: 100%;
                            height: 100%;
                            padding-bottom: 50px;
                        }
                        .swiper-slide {
                            text-align: center;
                            font-size: 18px;
                            background: #fff;
                            transform: scale(0.8);
                        }
                        .swiper-slide-active,.swiper-slide-duplicate-active{
                            transform: scale(1);
                        }
                        .swiper-slide {
                            width: 800px;
                        }
                        .swiper-slide-prev .slider-item {
                            cursor:pointer;
                            background-color: #f8f9fc !important;
                        }
                        .swiper-slide-next .slider-item {
                            cursor:pointer;
                            background-color: #f8f9fc !important;
                        }
                        .swiper-slide-active .slider-item {
                            padding-right: 40px;
                        }
                        .swiper-slide-prev .slider-item {
                            opacity: 0.3;
                        }
                        .swiper-slide-next .slider-item {
                            opacity: 0.3;
                        }
                        .swiper-pagination-bullet {
                            background: rgba(29, 29, 29, 0.30);
                            width:10px;
                            height:10px;
                        }
                        .swiper-pagination-bullet.swiper-pagination-bullet-active {
                            background: #1d1d1d;
                        }
                        .swiper-pagination{
                            margin-bottom:14px;
                        }
                        .swiper-slide .slider-item{
                            text-align:left;
                            font-family: Montserrat;
                        }
                        .slider-item .slider-title{
                            font-weight: 600;
                            line-height: 28px;
                            text-align: left;
                            color: #000;
                            font-size: 34px;
                            white-space: nowrap;
                        }
                        .slider-item .slider-desc{
                            font-weight: 500;
                            font-size: 19px;
                            line-height: 23px;
                            color: #89898e;
                        }
                        .slider-item .slider-image{
                            height:350px !important;
                            width:auto !important;
                        }
                    </style>
                    <div class="swiper swiper-container-${index}">
                        <div class="swiper-wrapper">
                            ${sliderHtml}
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                `);
                const containerName = `swiper-container-${index}`;
                const swipperInstance = new Swiper(`.${containerName}`, {
                    slidesPerView: "auto",
                    centeredSlides: true,
                    spaceBetween: 30,
                    pagination: {
                        el: `.${containerName} .swiper-pagination`,
                        clickable: true
                    },
                    loop: true,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    },
                    slideToClickedSlide: true,
                    autoplay: { delay: 3 * 1000 }
                });
                swipperInstance.update(true); // 在容器大小变化后调用 update 方法来解决偶尔不居中的问题
            });
        }
        // 自定义slider2
        customSlider2() {
            const $slideShows = $('[data-pf-type="Slideshow"]');
            if ($slideShows.length == 0) {
                return;
            }
            $slideShows.each((index, item) => {
                const $slideShow = $(item);
                if (!$slideShow.hasClass('custom-slider-2')) {
                    return;
                }
                this.insertSwipperCSS();
                $slideShow.hide();
                const $productBoxs = $slideShow.find('[data-pf-type="ProductBox"]');
                let arr = [];
                $productBoxs.each((index1, item1) => {
                    const $productBox = $(item1);
                    arr.push($productBox.prop("outerHTML").replace(/product-media-loading/g, '').replace(/button/g, 'div'));
                });

                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                           ${t}
                        </div>
                    `;
                }).join('');

                $slideShow.closest('[data-pf-type="Section"]').after(`
                    <style>
                        .swiper-custom-2-container{
                            margin:0 auto;
                            padding-left: ${this.contentLeft}px;
                            background-color:#f8f9fc;
                        }
                        .swiper-custom-2-container .swiper {
                            width: 100%;
                            height: 100%;
                            overflow: initial;
                        }
                        .swiper-custom-2-container .swiper-slide {
                            text-align: center;
                            background: #fff;
                            display: flex;
                            width: 268px !important;
                            height: 496px;
                        }
                        .swiper-custom-2-container .swiper-slide div[data-pf-type="ProductBox"]{
                            width:100%;
                        }
                        .swiper-custom-2-container [data-pf-type="Column"] {
                            height:auto  !important;
                        }
                        .swiper-custom-2-container [data-pf-type="ProductPrice2"]{
                            font-weight: 500;
                            font-size: 14px;
                            color: #1D1D1F;
                            text-align: center;
                            line-height: 18px;
                        }
                        .swiper-custom-2-container [data-product-type="title"] {
                            margin-top:32px !important;
                            margin-bottom:32px !important;
                            font-weight: 600;
                            font-size: 17px;
                            color: #000000;
                            text-align: center;
                            line-height: 21px;
                            min-height: 42px;
                        }
                        .swiper-custom-2-container .swiper-slide img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                        .swiper-custom-2-container .swiper-slide [data-pf-type="ProductATC2"]{
                            cursor:pointer;
                            margin:0 auto;
                            width: 114px;
                            height: 32px;
                            padding:6px 12px;
                            font-size: 14px;
                            font-weight: 600;
                        }
                        .swiper-custom-2-container .swiper-button-next:after,
                        .swiper-custom-2-container .swiper-rtl .swiper-button-prev:after {
                            content: '';
                        }
                        .swiper-custom-2-container .swiper-button-prev:after,
                        .swiper-custom-2-container .swiper-rtl .swiper-button-next:after {
                            content: '';
                        }
                        .swiper-custom-2-container .swiper-button-prev svg,
                        .swiper-custom-2-container .swiper-button-next svg{
                            width:40px;
                            height:40px;
                        }
                        .swiper-custom-2-container .swiper-button-prev, .swiper-rtl .swiper-button-next{
                            left:50%;
                            top:-70px;
                            width:40px;
                            height:40px;
                        }
                        .swiper-custom-2-container .swiper-button-next, .swiper-rtl .swiper-button-prev{
                            left:50%;
                            margin-left:49px;
                            top:-70px;
                            width:40px;
                            height:40px;
                        }
                        @media (max-width: 1024px) {
                            .swiper-custom-2-container .swiper {
                                padding-left:0;
                                overflow: hidden;
                            }
                            .swiper-custom-2-container .swiper {     
                            }
                            .swiper-custom-2-container .swiper-slide{
                                width:308px !important;
                                height:438px !important;
                                padding-top:28px;
                            }
                            .swiper-custom-2-container .swiper-button-prev,
                            .swiper-custom-2-container .swiper-button-next{
                                display:none;
                            } 
                            .swiper-custom-2-container .swiper-wrapper{
                                padding-bottom:46px;
                            }
                            .swiper-custom-2-container .swiper-pagination-bullet {
                                background:#D6D6D6;
                                width:8px;
                                height:8px;
                                opactiy:1;
                            }
                            .swiper-custom-2-container .swiper-pagination-bullet.swiper-pagination-bullet-active {
                                background:#707070;
                            }
                            .swiper-custom-2-container .swiper-slide img{
                                width:158px !important;
                                height:158px !important;
                            }
                            .swiper-custom-2-container{
                               padding-top: 12px;
                            }
                            .swiper-custom-2-container [data-pf-type="ProductMedia2"]{
                               margin-bottom:0;
                            }
                            .swiper-custom-2-container [data-product-type="title"]{
                                margin-top:40px !important;
                            }
                            .swiper-custom-2-container [data-pf-type="ProductPrice2"]{
                               margin-bottom:32px;
                            }
                        }
                    </style>
                    <div class="swiper-custom-2-container swiper-custom-2-container-${index}">
                        <div class="swiper">
                            <div class="swiper-wrapper">
                                ${sliderHtml}
                            </div>
                            <div class="swiper-button-prev">
                                ${theme.Global.getIcon('002', true)}
                            </div>
                            <div class="swiper-button-next">
                                ${theme.Global.getIcon('003', true)}
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                `);
                const containerName = `swiper-custom-2-container-${index}`;
                new Swiper(`.${containerName} .swiper`, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: this.isMobile,
                    slideToClickedSlide: false,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    },
                    autoplay: false,
                    pagination: this.isMobile ? {
                        el: `.${containerName} .swiper-pagination`,
                        clickable: true
                    } : false,
                });
            });
        }
        // 自定义slider3
        customSlider3() {
            const $slideShows = $('[data-pf-type="Slideshow"]');
            if ($slideShows.length == 0) {
                return;
            }
            $slideShows.each((index, item) => {
                const $slideShow = $(item);
                if (!$slideShow.hasClass('custom-slider-3')) {
                    return;
                }
                this.insertSwipperCSS();
                $slideShow.hide();
                const $imgEles = $slideShow.find('[data-pf-type="Image"]').filter((index1, item1) => {
                    if (this.isMobile) {
                        return $(item1).hasClass('pf-lg-hide');
                    } else {
                        return !$(item1).hasClass('pf-lg-hide');
                    }
                });
                let arr = [];
                $imgEles.each((index1, item1) => {
                    arr.push($(item1).html());
                });

                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                           ${t}
                        </div>
                    `;
                }).join('');

                $slideShow.after(`
                    <style>
                        .swiper-custom-3-container .swiper{
                            overflow: initial;
                        }
                        .swiper-custom-3-container .swiper-slide {
                            text-align: center;
                            display: flex;
                            width: 980px !important;
                            height: 500px;
                            border-radius: 16px;
                        }
                        .swiper-custom-3-container .swiper-slide img{
                            width:100% !important;
                            height:100% !important;
                        }
                        .swiper-custom-3-container .swiper-button-next:after,
                        .swiper-custom-3-container .swiper-rtl .swiper-button-prev:after {
                            content: '';
                        }
                        .swiper-custom-3-container .swiper-button-prev:after,
                        .swiper-custom-3-container .swiper-rtl .swiper-button-next:after {
                            content: '';
                        }
                        .swiper-custom-3-container .swiper-button-prev svg,
                        .swiper-custom-3-container .swiper-button-next svg{
                            width:32px;
                            height:32px;
                        }
                        .swiper-custom-3-container .swiper-button-prev, .swiper-rtl .swiper-button-next{
                            left:922px;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-3-container .swiper-button-next, .swiper-rtl .swiper-button-prev{
                            left:954px;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-3-container .swiper-button-next svg,.swiper-custom-3-container .swiper-button-prev svg{
                            fill:#fff;
                        }
                        .swiper-custom-3-container .swiper-pagination-bullets{
                            text-align: left;
                            bottom: -30px;
                            z-index:8;
                            width:250px;
                        }
                        .swiper-custom-3-container .swiper-pagination-bullet {
                            background:#707070;
                            width:8px;
                            height:8px;
                            opacity:1;
                        }
                        .swiper-custom-3-container .swiper-pagination-bullet.swiper-pagination-bullet-active {
                            background:#FFFFFF !important;
                        }
                        @media (max-width: 1024px) {
                            .swiper-custom-3-container .swiper {
                                padding-left:0;
                            }
                            .swiper-custom-3-container .swiper-slide {
                                width: 310px !important;
                                height: 480px;
                            }
                            .swiper-custom-3-container .swiper-button-prev,.swiper-custom-3-container .swiper-button-next{
                                display:none;
                            }
                            .swiper-custom-3-container .swiper-pagination-bullets{
                                text-align:center;
                                width:100%;
                            }
                        }
                    </style>
                    <div class="swiper-custom-3-container swiper-custom-3-container-${index}">
                        <div class="swiper">
                            <div class="swiper-wrapper">
                                ${sliderHtml}
                            </div>
                        </div>
                        <div class="swiper-button-prev">
                        ${theme.Global.getIcon('002', true)}
                        </div>
                        <div class="swiper-button-next">
                            ${theme.Global.getIcon('003', true)}
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                `);

                const containerName = `swiper-custom-3-container-${index}`;
                new Swiper(`.${containerName} .swiper`, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    },
                    autoplay: false,
                    pagination: {
                        el: `.${containerName} .swiper-pagination`,
                        clickable: true
                    }
                });
            });
        }
        // 自定义slider4
        customSlider4() {
            const $slideShows = $('[data-pf-type="Slideshow"]');
            if ($slideShows.length == 0) {
                return;
            }
            $slideShows.each((index, item) => {
                const $slideShow = $(item);
                if (!$slideShow.hasClass('custom-slider-4')) {
                    return;
                }
                this.insertSwipperCSS();
                $slideShow.hide();
                const $videoEles = $slideShow.find('[data-pf-type="HTML.Video"]').filter((index1, item1) => {
                    if (this.isMobile) {
                        return $(item1).hasClass('pf-lg-hide');
                    } else {
                        return !$(item1).hasClass('pf-lg-hide');
                    }
                });
                let arr = [];
                $videoEles.each((index1, item1) => {
                    arr.push($(item1).html());
                });

                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                           ${t}
                        </div>
                    `;
                }).join('');

                $slideShow.after(`
                    <style>
                        .swiper-custom-4-container .swiper{
                            overflow: initial;
                        }
                        .swiper-custom-4-container .swiper-slide {
                            text-align: center;
                            background: #fff;
                            display: flex;
                            width: 978px !important;
                            height: auto;
                            border-radius: 16px;
                        }
                        .swiper-custom-4-container .swiper-button-next:after,
                        .swiper-custom-4-container .swiper-rtl .swiper-button-prev:after {
                            content: '';
                        }
                        .swiper-custom-4-container .swiper-button-prev:after,
                        .swiper-custom-4-container .swiper-rtl .swiper-button-next:after {
                            content: '';
                        }
                        .swiper-custom-4-container .swiper-button-prev svg,
                        .swiper-custom-4-container .swiper-button-next svg{
                            width:32px;
                            height:32px;
                        }
                        .swiper-custom-4-container .swiper-button-prev, .swiper-rtl .swiper-button-next{
                            left:924px;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-4-container .swiper-button-next, .swiper-rtl .swiper-button-prev{
                            left:955px;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-4-container .swiper-pagination-bullets{
                            text-align: left;
                            bottom: -30px;
                            z-index:8;
                            width:250px;
                        }
                        .swiper-custom-4-container .swiper-pagination-bullet {
                            background:#D8D8D8;
                            width:8px;
                            height:8px;
                            opacity: 1;
                        }
                        .swiper-custom-4-container .swiper-pagination-bullet.swiper-pagination-bullet-active {
                            background:#707070;
                        }
                        @media (max-width: 1024px) {
                            .swiper-custom-4-container .swiper {
                                padding-left:0;
                            }
                            .swiper-custom-4-container .swiper-slide {
                                width: 310px !important;
                                height: 232px;
                            }
                            .swiper-custom-4-container .swiper-button-prev,.swiper-custom-4-container .swiper-button-next{
                                display:none;
                            }
                            .swiper-custom-4-container .swiper-pagination-bullets{
                                text-align:center;
                                width: 100vw;
                                left: calc(-2* var(--s-sm));
                            }
                        }
                    </style>
                    <div class="swiper-custom-4-container swiper-custom-4-container-${index}">
                        <div class="swiper">
                            <div class="swiper-wrapper">
                                ${sliderHtml}
                            </div>
                        </div>
                        <div class="swiper-button-prev">
                            ${theme.Global.getIcon('002', true)}
                        </div>
                        <div class="swiper-button-next">
                            ${theme.Global.getIcon('003', true)}
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                `);
                const containerName = `swiper-custom-4-container-${index}`;
                new Swiper(`.${containerName} .swiper`, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    },
                    autoplay: false,
                    pagination: {
                        el: `.${containerName} .swiper-pagination`,
                        clickable: true
                    },
                    on: {
                        slideChangeTransitionEnd: function (swiper) {
                            var el = swiper.el;
                            $(el).find('video').each((i, t) => {
                                if (i == this.activeIndex) {
                                    $(t).get(0).play();
                                } else {
                                    $(t).get(0).pause();
                                }
                            });
                        }
                    },
                });
            });
        }
        // 自定义slider5
        customSlider5() {
            const $slideShows = $('[data-pf-type="Slideshow"]');
            if ($slideShows.length == 0) {
                return;
            }
            $slideShows.each((index, item) => {
                const $slideShow = $(item);
                if (!$slideShow.hasClass('custom-slider-5')) {
                    return;
                }
                this.insertSwipperCSS();
                $slideShow.hide();
                const $imgEles = $slideShow.find('[data-pf-type="Image"]').filter((index1, item1) => {
                    if (this.isMobile) {
                        return $(item1).hasClass('pf-lg-hide');
                    } else {
                        return !$(item1).hasClass('pf-lg-hide');
                    }
                });
                let arr = [];
                $imgEles.each((index1, item1) => {
                    arr.push($(item1).html());
                });

                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                           ${t}
                        </div>
                    `;
                }).join('');

                $slideShow.after(`
                    <style>
                        .swiper-custom-5-container{
                            margin:0 auto;
                        }
                        .swiper-custom-5-container .swiper-slide {
                            text-align: center;
                            width: 100%;
                            height: 100%;
                            border-radius: 16px;
                            overflow: hidden;
                        }
                        .swiper-custom-5-container .swiper-slide img{
                            width:100% !important;
                            height:100% !important;
                            border-radius: 16px;
                        }
                        .swiper-custom-5-container .swiper-button-next:after,
                        .swiper-custom-5-container .swiper-rtl .swiper-button-prev:after {
                            content: '';
                        }
                        .swiper-custom-5-container .swiper-button-prev:after,
                        .swiper-custom-5-container .swiper-rtl .swiper-button-next:after {
                            content: '';
                        }
                        .swiper-custom-5-container .swiper-button-prev svg,
                        .swiper-custom-5-container .swiper-button-next svg{
                            width:32px;
                            height:32px;
                        }
                        .swiper-custom-5-container .swiper-button-prev, .swiper-rtl .swiper-button-next{
                            right:32px;
                            left:auto;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-5-container .swiper-button-next, .swiper-rtl .swiper-button-prev{
                            right:0;
                            left:auto;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-5-container .swiper-pagination-bullets{
                            text-align: left;
                            bottom:-34px;
                            z-index:8;
                            width:250px;
                        }
                        .swiper-custom-5-container .swiper-pagination-bullet{
                            background:#D8D8D8;
                            width:8px;
                            height:8px;
                            opacity:1;
                        }
                        .swiper-custom-5-container .swiper-pagination-bullet.swiper-pagination-bullet-active {
                            background:#707070 !important;
                        }
                        @media (max-width: 1024px) {
                            .swiper-custom-5-container .swiper-slide {
                                height: 450px;
                            }
                            .swiper-custom-5-container .swiper-button-prev,.swiper-custom-5-container .swiper-button-next{
                                display:none;
                            }
                            .swiper-custom-5-container .swiper-pagination-bullets{
                                text-align:center;
                                width:100%;
                            }
                        }
                    </style>
                    <div class="swiper-custom-5-container swiper-custom-5-container-${index}">
                        <div class="swiper">
                            <div class="swiper-wrapper">
                                ${sliderHtml}
                            </div>
                        </div>
                        <div class="swiper-button-prev">
                            ${theme.Global.getIcon('002', true)}
                        </div>
                        <div class="swiper-button-next">
                            ${theme.Global.getIcon('003', true)}
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                `);
                const containerName = `swiper-custom-5-container-${index}`;
                new Swiper(`.${containerName} .swiper`, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: this.isMobile,
                    slideToClickedSlide: false,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    },
                    autoplay: false,
                    pagination: {
                        el: `.${containerName} .swiper-pagination`,
                        clickable: true
                    }
                });
            });
        }
        // 自定义slider6
        customSlider6() {
            if (this.isMobile) {
                return;
            }
            const $slideShows = $('[data-pf-type="Slideshow"]');
            if ($slideShows.length == 0) {
                return;
            }
            $slideShows.each((index, item) => {
                const $slideShow = $(item);
                if (!$slideShow.hasClass('custom-slider-6')) {
                    return;
                }
                this.insertSwipperCSS();
                $slideShow.hide();
                const $imgEles = $slideShow.find('[data-pf-type="Image3"]').filter((index1, item1) => {
                    if (this.isMobile) {
                        return $(item1).hasClass('pf-lg-hide');
                    } else {
                        return !$(item1).hasClass('pf-lg-hide');
                    }
                });
                let arr = [];
                $imgEles.each((index1, item1) => {
                    arr.push({
                        img: $(item1).prop("outerHTML"),
                        text: $(item1).prev('h3').prop("outerHTML")
                    });
                });

                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                           <div class="d-flex flex-column w-100">
                                ${t.text}
                                ${t.img}
                           </div>
                        </div>
                    `;
                }).join('');

                $slideShow.after(`
                    <style>
                        .swiper-custom-6-container .swiper{
                            overflow: initial;
                        }
                        .swiper-custom-6-container .swiper-slide {
                            text-align: center;
                            display: flex;
                            width: 616px !important;
                            border-radius: 16px;
                        }
                        .swiper-custom-6-container .swiper-slide h3{
                            text-align: left;
                            width: 430px;
                            min-height: 50px;
                            margin-bottom: 24px;
                        }
                        .swiper-custom-6-container .swiper-slide img{
                            width:100% !important;
                            height:362px !important;
                        }
                        .swiper-custom-6-container .swiper-button-next:after,
                        .swiper-custom-6-container .swiper-rtl .swiper-button-prev:after {
                            content: '';
                        }
                        .swiper-custom-6-container .swiper-button-prev:after,
                        .swiper-custom-6-container .swiper-rtl .swiper-button-next:after {
                            content: '';
                        }
                        .swiper-custom-6-container .swiper-button-prev svg,
                        .swiper-custom-6-container .swiper-button-next svg{
                            width:27px;
                            height:27px;
                        }
                        .swiper-custom-6-container .swiper-button-prev, .swiper-rtl .swiper-button-next{
                            right:35px;
                            left:auto;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-6-container .swiper-button-next, .swiper-rtl .swiper-button-prev{
                            right:0;
                            left:auto;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-6-container .swiper-pagination-bullets{
                            display:none;
                        }
                        @media (max-width: 1024px) {
                            .swiper-custom-6-container .swiper {
                                padding-left:0;
                            }
                            .swiper-custom-6-container .swiper-slide {
                                width: 310px !important;
                                height: 480px;
                            }
                            .swiper-custom-6-container .swiper-button-prev,.swiper-custom-6-container .swiper-button-next{
                                display:none;
                            }
                            .swiper-custom-6-container .swiper-pagination-bullets{
                                text-align:center;
                                width:100%;
                            }
                        }
                    </style>
                    <div class="swiper-custom-6-container swiper-custom-6-container-${index}">
                        <div class="swiper">
                            <div class="swiper-wrapper">
                                ${sliderHtml}
                            </div>
                        </div>
                        <div class="swiper-button-prev">
                           ${theme.Global.getIcon('002', true)}
                        </div>
                        <div class="swiper-button-next">
                          ${theme.Global.getIcon('003', true)}
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                `);

                const containerName = `swiper-custom-6-container-${index}`;
                new Swiper(`.${containerName} .swiper`, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    },
                    autoplay: false,
                    pagination: {
                        el: `.${containerName} .swiper-pagination`,
                        clickable: true
                    }
                });
            });
        }
        // 自定义slider7
        customSlider7() {
            if (this.isMobile) {
                return;
            }
            const $slideShows = $('[data-pf-type="Slideshow"]');
            if ($slideShows.length == 0) {
                return;
            }
            $slideShows.each((index, item) => {
                const $slideShow = $(item);
                if (!$slideShow.hasClass('custom-slider-7')) {
                    return;
                }
                this.insertSwipperCSS();
                $slideShow.hide();
                const $imgEles = $slideShow.find('[data-pf-type="Image3"]').filter((index1, item1) => {
                    if (this.isMobile) {
                        return $(item1).hasClass('pf-lg-hide');
                    } else {
                        return !$(item1).hasClass('pf-lg-hide');
                    }
                });
                let arr = [];
                $imgEles.each((index1, item1) => {
                    arr.push({
                        img: $(item1).prop("outerHTML"),
                        text: $(item1).next('p').prop("outerHTML")
                    });
                });

                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                           <div class="d-flex flex-column w-100">
                                ${t.img}
                                ${t.text}
                            </div>
                        </div>
                    `;
                }).join('');

                $slideShow.after(`
                    <style>
                        .swiper-custom-7-container .swiper{
                            overflow: initial;
                        }
                        .swiper-custom-7-container .swiper-slide {
                            text-align: center;
                            display: flex;
                            width: 314px !important;
                            border-radius: 16px;
                        }
                        .swiper-custom-7-container .swiper-slide h3{
                            text-align: left;
                            width: 430px;
                            min-height: 50px;
                            margin-bottom: 24px;
                        }
                        .swiper-custom-7-container .swiper-slide img{
                            width:316px !important;
                            height:360px !important;
                        }
                        .swiper-custom-7-container .swiper-button-next:after,
                        .swiper-custom-7-container .swiper-rtl .swiper-button-prev:after {
                            content: '';
                        }
                        .swiper-custom-7-container .swiper-button-prev:after,
                        .swiper-custom-7-container .swiper-rtl .swiper-button-next:after {
                            content: '';
                        }
                        .swiper-custom-7-container .swiper-button-prev svg,
                        .swiper-custom-7-container .swiper-button-next svg{
                        }
                        .swiper-custom-7-container .swiper-button-prev, .swiper-rtl .swiper-button-next{
                            right:calc(132px + 50px);
                            left:auto;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-7-container .swiper-button-disabled {
                            background: #F4F4F4 !important;
                            border: 1px solid #F4F4F4 !important;
                        }
                        .swiper-custom-7-container .swiper-button-disabled svg {
                            fill: #000 !important;
                        }
                        .swiper-custom-7-container .swiper-pagination {
                            position: absolute;
                            height: 32px;
                            width: 100% !important;
                            text-align: center;
                            display: inline-block;
                            bottom:-50px;
                            color: #000;
                            font-family: Montserrat;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 32px;
                            z-index: -1;
                        }
                        .swiper-custom-7-container .swiper-pagination-content {
                            position: absolute;
                            right: 50px;
                            width: 132px;
                        }

                        .swiper-custom-7-container .swiper-button-next, .swiper-rtl .swiper-button-prev{
                            right:0;
                            left:auto;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-7-container .swiper-pagination-bullets{
                            display:none;
                        }

                        

                        .swiper-button-next-7, .swiper-button-prev-7 {
                            width: 50px !important;
                            height: 32px !important;
                            border-radius: 16px !important;
                            background: #000 !important;
                        }

                        .swiper-button-prev-7.not-first-7, .swiper-button-next-7.not-first-7{
                            width: 50px !important;
                            height: 32px !important;
                            background: transparent !important;
                            border: none !important;
                        }

                        .swiper-button-next-7 svg, .swiper-button-prev-7 svg {
                            fill: #fff !important;
                        }

                        @media (max-width: 1024px) {
                            .swiper-custom-7-container .swiper {
                                padding-left:0;
                            }
                            .swiper-custom-7-container .swiper-slide {
                                width: 310px !important;
                                height: 480px;
                            }
                            .swiper-custom-7-container .swiper-button-prev,.swiper-custom-7-container .swiper-button-next{
                                display:none;
                            }
                            .swiper-custom-7-container .swiper-pagination-bullets{
                                text-align:center;
                                width:100%;
                            }
                        }
                    </style>
                    <div class="swiper-custom-7-container swiper-custom-7-container-${index}">
                        <div class="swiper">
                            <div class="swiper-wrapper">
                                ${sliderHtml}
                            </div>
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-7">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-7 not-first-7">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-7 not-first-7">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-7 not-first-7">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-7 not-first-7">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-pagination">
                        ${1} of ${2}
                        </div>
                        <div class="swiper-button-next swiper-button-next-7">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-7 not-first-7">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-7 not-first-7">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-7 not-first-7">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-7 not-first-7">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-7 not-first-7">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                    </div>
                `);

                const containerName = `swiper-custom-7-container-${index}`;
                new Swiper(`.${containerName} .swiper`, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    },
                    autoplay: false,
                    pagination: {
                        el: `.${containerName} .swiper-pagination`,
                        type: 'fraction',
                        renderFraction: function (currentClass, totalClass) {
                            return '<div class="swiper-pagination-content">' +
                                '<span class="' + currentClass + '"></span>' +
                                ' of ' +
                                '<span class="' + totalClass + '"></span>' +
                                '</div>'
                                ;

                        },
                    }
                });
            });
        }
        // 自定义slider8
        customSlider8() {
            if (!this.isMobile) {
                return;
            }
            const $slideShows = $('[data-pf-type="Slideshow"]');
            if ($slideShows.length == 0) {
                return;
            }
            $slideShows.each((index, item) => {
                const $slideShow = $(item);
                if (!$slideShow.hasClass('custom-slider-8')) {
                    return;
                }
                this.insertSwipperCSS();
                $slideShow.hide();
                const $imgEles = $slideShow.find('[data-pf-type="Image3"]');
                let arr = [];
                $imgEles.each((index1, item1) => {
                    arr.push({
                        img: $(item1).prop("outerHTML"),
                        text: $(item1).next('p').prop("outerHTML")
                    });
                });

                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                           <div class="d-flex flex-column w-100">
                                ${t.img}
                                ${t.text}
                           </div>
                        </div>
                    `;
                }).join('');

                $slideShow.after(`
                    <style>
                        .swiper-custom-8-container .swiper{
                            overflow: initial;
                        }
                        .swiper-custom-8-container .swiper-slide {
                            text-align: center;
                            display: flex;
                            width: 314px !important;
                            border-radius: 16px;
                        }
                        .swiper-custom-8-container .swiper-slide h3{
                            text-align: left;
                            width: 430px;
                            min-height: 50px;
                            margin-bottom: 24px;
                        }
                        .swiper-custom-8-container .swiper-slide img{
                            width:280px !important;
                            height:360px !important;
                        }
                        .swiper-custom-8-container .swiper-button-next:after,
                        .swiper-custom-8-container .swiper-rtl .swiper-button-prev:after {
                            content: '';
                        }
                        .swiper-custom-8-container .swiper-button-prev:after,
                        .swiper-custom-8-container .swiper-rtl .swiper-button-next:after {
                            content: '';
                        }
                        .swiper-custom-8-container .swiper-button-prev svg,
                        .swiper-custom-8-container .swiper-button-next svg{
                        }
                        .swiper-custom-8-container .swiper-button-prev, .swiper-rtl .swiper-button-next{
                            right:calc(132px + 50px);
                            left:auto;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-8-container .swiper-button-disabled {
                            background: #F4F4F4 !important;
                            border: 1px solid #F4F4F4 !important;
                        }
                        .swiper-custom-8-container .swiper-button-disabled svg {
                            fill: #000 !important;
                        }
                        .swiper-custom-8-container .swiper-pagination {
                            position: absolute;
                            height: 32px;
                            width: 100% !important;
                            text-align: center;
                            display: inline-block;
                            bottom:-50px;
                            color: #000;
                            font-family: Montserrat;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 32px;
                            z-index: -1;
                        }
                        .swiper-custom-8-container .swiper-pagination-content {
                            position: absolute;
                            right: 50px;
                            width: 132px;
                        }

                        .swiper-custom-8-container .swiper-button-next, .swiper-rtl .swiper-button-prev{
                            right:0;
                            left:auto;
                            top:auto;
                            bottom:-50px;
                        }
                        .swiper-custom-8-container .swiper-pagination-bullets{
                            display:none;
                        }

                        

                        .swiper-button-next-8, .swiper-button-prev-8 {
                            width: 50px !important;
                            height: 32px !important;
                            border-radius: 16px !important;
                            background: #000 !important;
                        }

                        .swiper-button-prev-8.not-first-8, .swiper-button-next-8.not-first-8{
                            width: 50px !important;
                            height: 32px !important;
                            background: transparent !important;
                            border: none !important;
                        }

                        .swiper-button-next-8 svg, .swiper-button-prev-8 svg {
                            fill: #fff !important;
                        }

                        @media (max-width: 1024px) {
                            .swiper-custom-8-container .swiper {
                                padding-left:0;
                            }
                            .swiper-custom-8-container .swiper-slide {
                                width: 280px !important;
                                height: 410px;
                            }
                            .swiper-custom-8-container .swiper-pagination-bullets{
                                text-align:center;
                                width:100%;
                            }
                        }
                    </style>
                    <div class="swiper-custom-8-container swiper-custom-8-container-${index}">
                        <div class="swiper">
                            <div class="swiper-wrapper">
                                ${sliderHtml}
                            </div>
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-8">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-8 not-first-8">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-8 not-first-8">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-8 not-first-8">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-button-prev swiper-button-prev-8 not-first-8">
                           ${theme.Global.getIcon('006', true)}
                        </div>
                        <div class="swiper-pagination">
                        ${1} of ${2}
                        </div>
                        <div class="swiper-button-next swiper-button-next-8">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-8 not-first-8">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-8 not-first-8">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-8 not-first-8">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-8 not-first-8">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                        <div class="swiper-button-next swiper-button-next-8 not-first-8">
                          ${theme.Global.getIcon('007', true)}
                        </div>
                    </div>
                `);

                const containerName = `swiper-custom-8-container-${index}`;
                new Swiper(`.${containerName} .swiper`, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    },
                    autoplay: false,
                    pagination: {
                        el: `.${containerName} .swiper-pagination`,
                        type: 'fraction',
                        renderFraction: function (currentClass, totalClass) {
                            return '<div class="swiper-pagination-content">' +
                                '<span class="' + currentClass + '"></span>' +
                                ' of ' +
                                '<span class="' + totalClass + '"></span>' +
                                '</div>'
                                ;

                        },
                    }
                });
            });
        }
        // 计算left值
        calcLeft() {
            const $contentLeft = $('.content-left');
            if ($contentLeft.length > 0) {
                this.contentLeft = $contentLeft.get(0).getBoundingClientRect().left;
            } else {
                this.contentLeft = 0;
            }
        }
        handleLeftChange() {
            if (!this.isMobile) {
                $('.swiper-custom-2-container').css('paddingLeft', this.contentLeft + 'px');
                $('.collection-module').children('div').css('paddingLeft', this.contentLeft + 'px');
            }
        }
        // 插入css样式
        insertSwipperCSS() {
            if (!this.hasAppendSwiperCSS) {
                $('head').append(`
                    <style>
                        @font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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');font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-pointer-events{touch-action:pan-y}.swiper-pointer-events.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center}.swiper-virtual .swiper-slide{-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:'prev'}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:'next'}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:50%;background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-cube.swiper-rtl .swiper-slide{transform-origin:100% 0}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-next,.swiper-cube .swiper-slide-next+.swiper-slide,.swiper-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-cube .swiper-slide-shadow-bottom,.swiper-cube .swiper-slide-shadow-left,.swiper-cube .swiper-slide-shadow-right,.swiper-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-flip{overflow:visible}.swiper-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-flip .swiper-slide-active,.swiper-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-flip .swiper-slide-shadow-bottom,.swiper-flip .swiper-slide-shadow-left,.swiper-flip .swiper-slide-shadow-right,.swiper-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-creative .swiper-slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards .swiper-slide{transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden} 
                    </style>
                `);
                this.hasAppendSwiperCSS = true;
            }
        }
        // tab下的自定义的slider
        collectionTabSlider() {
            const $productList = $('.collection-tabs').find('[data-pf-type="ProductList"]');
            if ($productList.length == 0) {
                return;
            }
            this.insertSwipperCSS();
            $('.collection-module').before(`
                <style>
                    .collection-tabs [data-pf-type="TabsMenu"] {
                        background: #EFEFEF;
                        border-radius: 20px;
                        width: 460px;
                        height: 40px;
                        padding: 4px;
                    }
                    .collection-tabs [data-pf-type="TabsMenu"]::-webkit-scrollbar{
                        height:0;
                    }
                    .collection-tabs [data-pf-type="TabsMenu"] [data-pf-type="TabHeader2"]:nth-child(1){
                        margin-left:4px;
                    }
                    .collection-tabs{
                        padding:0;
                    }
                    .collection-module [data-pf-type="TabsContent"] [data-pf-type="Column"]{
                        text-align:left;
                        width:100% !important;
                    }
                    .tabs-slider{
                        margin:0 auto;
                        margin-left: 16px;
                    }
                    .tabs-slider .swiper {
                        width: 100%;
                        height: 100%;
                    }
                    .tabs-slider .swiper-slide {
                        text-align: center;
                        background: #fff;
                        width: 268px !important;
                        height: 496px;
                    }
                    .tabs-slider .swiper-slide div[data-pf-type="ProductBox"]{
                        width:100%;
                    }
                    .tabs-slider [data-pf-type="Column"] {
                        height:auto  !important;
                    }
                    .tabs-slider [data-pf-type="ProductPrice2"]{
                        font-weight: 500;
                        font-size: 14px;
                        color: #1D1D1F;
                        text-align: center;
                        line-height: 18px;
                    }
                    .tabs-slider [data-product-type="title"] {
                        margin-top:32px !important;
                        margin-bottom:32px !important;
                        font-weight: 600;
                        font-size: 17px;
                        color: #000000;
                        text-align: center;
                        line-height: 21px;
                        min-height: 42px;
                    }
                    .tabs-slider .swiper-slide img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    .tabs-slider .swiper-slide [data-pf-type="ProductATC2"]{
                        cursor:pointer;
                        margin:0 auto;
                        width: 114px;
                        height: 32px;
                        padding:6px 12px;
                        font-size: 14px;
                        font-weight: 600;
                    }
                    .tabs-slider .swiper-button-next:after,
                    .tabs-slider .swiper-rtl .swiper-button-prev:after {
                        content: '';
                    }
                    .tabs-slider .swiper-button-prev:after,
                    .tabs-slider .swiper-rtl .swiper-button-next:after {
                        content: '';
                    }
                    .tabs-slider .swiper-button-prev svg,
                    .tabs-slider .swiper-button-next svg{
                        width:40px;
                        height:40px;
                    }
                    .tabs-slider .swiper-button-prev, .swiper-rtl .swiper-button-next{
                        left:50%;
                        top:-36px;
                        width:40px;
                        height:40px;
                    }
                    .tabs-slider .swiper-button-next, .swiper-rtl .swiper-button-prev{
                        left:50%;
                        margin-left:49px;
                        top:-36px;
                        width:40px;
                        height:40px;
                    }
                    @media (max-width: 1024px) {
                        .collection-module [data-pf-type="TabsContent"]{
                            padding-top:0;
                        }
                        .collection-module [data-pf-type="TabsContent"] [data-pf-type="Column"]{
                            text-align:center;
                            margin: 0 auto;
                        }
                        .collection-tabs [data-pf-type="TabsMenu"] {
                            background: none;
                            border-radius: 0;
                            width:100%;
                        }
                        .collection-tabs [data-pf-type="TabHeader2"]{
                            background:none;
                            font-weight: 500;
                            font-size: 14px;
                            color: #868686;
                        }
                        .collection-tabs [data-pf-type=TabHeader2][data-pf-tab-active=true]{
                            background:none !important;
                            border-radius:0 !important;
                            font-weight: 600;
                            font-size: 14px;
                            color: #000000;
                            position:relative;
                        }
                        .collection-tabs [data-pf-type=TabHeader2][data-pf-tab-active=true]:after{
                            content: "";
                            position: absolute;
                            left: 0;
                            bottom:0;
                            width: 100%;
                            background:#000000;
                            display:inline-block;
                            height: 2px;
                        }
                        .collection-module [data-pf-type="TabsContent"] [data-pf-type="Column"] img {
                            width: 308px;
                            height: 438px;
                            border-radius: 16px;
                            display: inline-block;
                        }
                        .tabs-slider {
                            margin-left:24px !important;
                        }
                        .tabs-slider .swiper-slide img.collection-faceimage{
                            width: 100% !important;
                            height: 100% !important;
                        }
                        .tabs-slider .swiper-slide{
                            width:308px !important;
                            height:438px !important;
                            border-radius: 16px;
                        }
                        .tabs-slider .swiper-wrapper{
                            padding-bottom:46px;
                        }
                        .tabs-slider .swiper-button-prev, .swiper-rtl .swiper-button-next{
                            left:auto;
                            top:50%;
                            width:30px;
                            height:30px;
                            opacity:0.5;
                        }
                        .tabs-slider .swiper-button-next, .swiper-rtl .swiper-button-prev{
                            left:auto;
                            top:50%;
                            width:30px;
                            height:30px;
                            opacity:0.5;
                        }
                        .tabs-slider .swiper-button-prev svg, .tabs-slider .swiper-button-next svg{
                            width:30px;
                            height:30px;
                        }
                        .tabs-slider .swiper-pagination{
                            display:none;
                        }
                        .tabs-slider .swiper-pagination-bullet {
                            background:#D6D6D6;
                            width:8px;
                            height:8px;
                            opacity:1;
                        }
                        .tabs-slider .swiper-pagination-bullet.swiper-pagination-bullet-active {
                            background:#707070;
                        }
                        .tabs-slider .swiper-slide img{
                            width:158px !important;
                            height:158px !important;
                        }
                        .tabs-slider{
                            margin-top: 32px;
                        }
                        .tabs-slider [data-pf-type="ProductMedia2"]{
                            margin-bottom:0;
                        }
                        .tabs-slider [data-product-type="title"]{
                            margin-top:40px !important;
                        }
                        .tabs-slider [data-pf-type="ProductPrice2"]{
                            margin-bottom:32px;
                        }
                    }
                </style> 
            `);
            if (!this.isMobile) {
                const cw = $('.collection-module').children('div').eq(0).css('--cw');
                $('.collection-module').children('div').css({
                    'padding-left': `calc((100vw - ${cw}) / 2)`,
                    '--cw': '100%'
                });
                const $rows = $('.collection-tabs [data-pf-type="TabsContent"]').children('[data-pf-type="Row"]');
                $rows.each((index, item) => {
                    const $pf = $(item).children('.pf-c');
                    $pf.eq(0).css('--c-lg', 3);
                    $pf.eq(1).css('--c-lg', 9);
                });
            } else {
                const $rows = $('.collection-tabs [data-pf-type="TabsContent"]').children('[data-pf-type="Row"]');
                $rows.each((index, item) => {
                    const $pf = $(item).children('.pf-c');
                    $pf.eq(0).hide();
                });
            }
            $productList.each((index, item) => {
                $(item).hide();
                const $productBoxs = $(item).find('[data-pf-type="ProductBox"]');
                let arr = [];
                $productBoxs.each((index1, item1) => {
                    const $productBox = $(item1);
                    arr.push($productBox.prop("outerHTML").replace(/product-media-loading/g, '').replace(/button/g, 'div'));
                });
                if (this.isMobile) {
                    arr.unshift($('.collection-tabs').find('.collection-faceimage').eq(index).prop("outerHTML"));
                }
                // 渲染html
                let sliderHtml = arr.map(t => {
                    return `
                        <div class="swiper-slide">
                           ${t}
                        </div>
                    `;
                }).join('');

                let swiperButtonHtml = `
                    <div class="swiper-button-prev">
                        ${theme.Global.getIcon('002', true)}
                    </div>
                    <div class="swiper-button-next">
                        ${theme.Global.getIcon('003', true)}
                    </div>
                `;
                if (this.isMobile) {
                    swiperButtonHtml = `
                        <div class="swiper-button-prev">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-006" viewBox="0 0 24 24">
                                <g>
                                    <path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449
                                        s-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049
                                        c-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75
                                        c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"/>
                                </g>
                            </svg>
                        </div>
                        <div class="swiper-button-next">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24">
                                <g>
                                    <path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449
                                        c0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75
                                        c0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127
                                        c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127
                                        C6.767,21.236,6.708,21.086,6.708,20.917z"/>
                                </g>
                            </svg>
                        </div>
                    `;
                }
                $(item).after(`
                    <div class="tabs-slider tabs-slider-${index}">
                        <div class="swiper">
                            <div class="swiper-wrapper">
                                ${sliderHtml}
                            </div>
                            ${this.isMobile ? swiperButtonHtml : ''}
                            <div class="swiper-pagination"></div>
                        </div>
                        ${!this.isMobile ? swiperButtonHtml : ''}
                    </div>
                `);
                const containerName = `tabs-slider-${index}`;
                new Swiper(`.${containerName} .swiper`, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    autoplay: false,
                    navigation: {
                        nextEl: `.${containerName} .swiper-button-next`,
                        prevEl: `.${containerName} .swiper-button-prev`,
                    }
                });
            });
        }
        bindEvent() {
            $(window).resize(theme.throttle(() => {
                this.calcLeft();
                this.handleLeftChange();
            }, 200));
        }
        // 改变tab切换的按钮
        changeTabButton() {
            const $redColor = $('.red-color'),
                $greyColor = $('.grey-color'),
                $parentEle = $redColor.parent();
            if ($redColor.length == 0 || $greyColor.length == 0) {
                return;
            }
            $parentEle.before(`
                <style>
                    .circle{
                        width: 28px;
                        height: 28px;
                        position: relative;
                        box-sizing: border-box;
                    }
                    .big{
                        width: 28px;
                        height: 28px;
                        border-radius:50% ;
                        position: absolute;
                        margin: auto; 
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        box-sizing: border-box;
                    }
                    .small{
                        width: 20px;
                        height: 20px;
                        border-radius:50%;
                        position: absolute;
                        margin: auto;
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        box-sizing: border-box;
                    }
                    .red-btn .small{
                        background: #D42227;
                        box-shadow: inset 0 2px 3px 0 #8A1216;
                    }
                    .grey-btn .small{
                        background: #9DB3CE;
                        box-shadow: inset 0 1px 3px 0 #00000080;
                    }
                    [data-pf-tab-active="true"] .circle .big{
                        border: 1px solid #53AAFF;
                        box-shadow: inset 0 1px 3px 0 #00000080;
                    }
                    .red-operator,.grey-operator{
                        display:flex;
                        align-items:center;
                    }
                    .red-color,.grey-color{
                        padding:12px 4px;
                    }
                    .red-color .red-text{
                        display:none;
                    }
                    .grey-color .grey-text{
                        margin-left:16px;
                        width:90px;
                    }
                    .accessories-column img.active,.accessories-column img:hover {
                        box-shadow: rgba(0,0,0, .1) 0 0 12px;
                    }
                </style>
            `);
            if (!this.isMobile) {
                $parentEle.addClass('text-right').css({
                    'margin': '16px 0 0px 500px',
                    'width': '200px'
                });
            } else {
                $parentEle.addClass('text-center');
            }
            const redText = $redColor.html(), greyText = $greyColor.html();
            let html1 = `
              <div class="red-operator">
                <div class="circle red-btn">
                    <div class="big"></div>
                    <div class="small"></div>
                </div>
                <span class="red-text">${redText}</span>
              </div>
            `;
            let html2 = `
              <div class="grey-operator">
                <div class="circle grey-btn">
                    <div class="big"></div>
                    <div class="small"></div>
                </div>
                <span class="grey-text">${redText}</span>
              </div>
            `;
            $redColor.html(html1);
            $greyColor.html(html2);
            // 绑定事件
            const $greyText = $('.grey-operator .grey-text');
            $redColor.click(() => {
                $greyText.text(redText);
            });
            $greyColor.click(() => {
                $greyText.text(greyText);
            });
        }
        // 配件切换
        accessoriesSwitch() {
            if (!this.isMobile) {
                const accessoriesList = $('#accessories-list-pc').get(0);
                if (!accessoriesList) {
                    return;
                }
                $('#accessories-list-pc').before(`
                    <style>
                        .accessories-column img {
                            cursor: pointer;
                        }
                    
                        .accessories-column img.active,
                        .accessories-column img:hover {
                            box-shadow: rgba(0, 0, 0, .1) 0 0 12px;
                        }
                    </style>
                `);
                const accessoriesItems = $('.accessories-column img');
                const handleAccessoriesPcListClick = (e) => {
                    const clickedItem = e.target;
                    if (clickedItem.nodeName === 'IMG') {
                        const classNameMatchInfo = clickedItem.className.match(/accessories-item-\d+$/);
                        if (classNameMatchInfo) {
                            accessoriesItems.each((index, item) => {
                                item.classList.remove('active');
                            });
                            const matchedClassName = classNameMatchInfo[0];
                            const clickedAccessories = document.querySelector(`img.${matchedClassName}`);
                            clickedAccessories.classList.add('active');
                            const replaceGoalAccessories = document.querySelector(`div.${matchedClassName}`);
                            const mainAccessories = $('#accessories-main-show').get(0);
                            Array.from(mainAccessories.children).map((child) => {
                                mainAccessories.removeChild(child);
                            });
                            Array.from(replaceGoalAccessories.cloneNode(true).children).map((child) => {
                                mainAccessories.appendChild(child);
                            });
                        }
                    }
                };
                if (accessoriesItems.length) {
                    accessoriesItems.get(0).classList.add('active');
                }
                accessoriesList.addEventListener('click', handleAccessoriesPcListClick);
            } else {
                const accessoriesList = $('#accessories-list-mobile').get(0);
                if (!accessoriesList) {
                    return;
                }
                const modalStyle = document.createElement('style');
                modalStyle.innerHTML = `
                        .accessories-modal .mask {
                            position: fixed;
                            z-index: 1000;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            background: rgba(0,0,0,0.6);
                        }
                        .accessories-modal .modal-content {
                            position: fixed;
                            z-index: 1000;
                            bottom: 70px;
                            background: white;
                            display: flex;
                            flex-direction: column;
                            width: calc(100vw - 16px);
                            align-items: center;
                            padding: 48px 48px;
                            margin: 0 8px 8px;
                            border-radius: 24px;
                            color: #1d1d1d;
                        }
                        .accessories-modal .accessories-title {
                            font-weight: 600;
                            font-size: 19px;
                            text-align: center;
                            line-height: 23px;
                        }
                        .accessories-modal .accessories-desc {
                            font-weight: 500;
                            font-size: 14px;
                            text-align: center;
                            line-height: 20px;
                        }
                        .accessories-modal a {
                            display: block;
                            width: 100%;
                            height: 40px;
                            background: #28BE44;
                            padding: 0;
                            border-radius: 20px;
                            margin-top: 40px;
                            color: white;
                            line-height: 40px;
                            text-align: center;
                            font-weight: bold;
                        }
                        .accessories-modal .close-icon {
                            z-index: 1000;
                            position: absolute;
                            top: 12px;
                            width: 24px;
                            height: 24px;
                            right: 12px;
                            fill: #989898;
                            font-size: 14px;
                        }
                `;
                const mask = document.createElement('div');
                mask.setAttribute('class', 'mask');
                const modalContent = document.createElement('div');
                modalContent.setAttribute('class', 'modal-content');

                const closeIcon = document.createElement('span');
                closeIcon.setAttribute('class', 'close-icon');
                closeIcon.innerHTML = `<svg viewBox="0 0 24 24">
                <g >
                    <path d="M19.583,4.965c0,0.17-0.059,0.319-0.176,0.449l-6.445,6.426l6.445,6.426c0.117,0.131,0.176,0.28,0.176,0.449
                        c0,0.17-0.059,0.319-0.176,0.449c-0.065,0.053-0.137,0.095-0.215,0.127c-0.078,0.033-0.156,0.049-0.234,0.049
                        s-0.156-0.016-0.234-0.049c-0.078-0.032-0.15-0.074-0.215-0.127l-6.426-6.445l-6.426,6.445c-0.065,0.053-0.137,0.095-0.215,0.127
                        c-0.078,0.033-0.156,0.049-0.234,0.049s-0.156-0.016-0.234-0.049c-0.078-0.032-0.15-0.074-0.215-0.127
                        c-0.117-0.13-0.176-0.279-0.176-0.449c0-0.169,0.059-0.318,0.176-0.449l6.445-6.426L4.759,5.414
                        c-0.117-0.13-0.176-0.279-0.176-0.449c0-0.169,0.059-0.318,0.176-0.449c0.13-0.117,0.28-0.176,0.449-0.176
                        c0.169,0,0.319,0.059,0.449,0.176l6.426,6.445l6.426-6.445c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176
                        C19.524,4.646,19.583,4.796,19.583,4.965z"/>
                    </g>
                <svg>`;
                const modal = document.createElement('div');
                modal.setAttribute('class', 'accessories-modal d-none');
                modal.appendChild(modalStyle);
                modal.appendChild(mask);
                modal.appendChild(modalContent);
                const handleClose = () => {
                    modal.classList.add('d-none');
                };

                const handleAccessoriesMobileListClick = (e) => {
                    const clickedItem = e.target;
                    if (clickedItem.nodeName === 'IMG') {
                        const classNameMatchInfo = clickedItem.className.match(/accessories-mobile-item-\d+$/);
                        if (classNameMatchInfo) {
                            const matchedClassName = classNameMatchInfo[0];
                            const replaceGoalAccessories = document.querySelector(`div.${matchedClassName}`);
                            modalContent.innerHTML = replaceGoalAccessories.innerHTML;
                            modalContent.appendChild(closeIcon);
                            modal.classList.remove('d-none');
                        }
                    }
                };
                accessoriesList.addEventListener('click', handleAccessoriesMobileListClick);

                closeIcon.addEventListener('click', handleClose);
                mask.addEventListener('click', handleClose);
                document.body.appendChild(modal);
            }
        }

    }

    theme.AssetsLoader.onPageLoaded(function () {
        new GeneralBusinessLogic();
    });
})(jQueryTheme);